
<router-outlet></router-outlet>

<!-- Floating WhatsApp Button -->
<a
  class="whatsapp-fab"
  [class.visible]="showWhatsAppFab"
  href="https://wa.me/972545602139"
  target="_blank"
  aria-label="צ׳אט בוואטסאפ"
  title="צ׳אט בוואטסאפ"
  rel="noopener"
>
  <i class="fab fa-whatsapp" aria-hidden="true"></i>
</a>